var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.601 12.405L14.9997 14",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7H8.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3H14.5C15.6046 3 16.5 3.89543 16.5 5V9C16.5 11.2091 14.7091 13 12.5 13V13C10.2909 13 8.5 11.2091 8.5 9V5C8.5 3.89543 9.39543 3 10.5 3Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.401 12.405L9.65798 15.377",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.0642C12.0898 16.3441 10.6263 16.0468 9.437 15.239C9.23736 15.1061 8.99315 15.0579 8.758 15.105L5.912 15.674C4.5095 15.9543 3.49991 17.1857 3.5 18.616V19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.1566V19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 20.5,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3303 16.5172L18.5 16.6895L18.6754 16.5041C18.9731 16.1865 19.3877 16.0044 19.823 16C20.2583 15.9957 20.6764 16.1694 20.9804 16.481L21.0161 16.5172C21.6613 17.1803 21.6613 18.2366 21.0161 18.8997L19.2618 20.6809C19.0609 20.8851 18.7864 21 18.5 21C18.2136 21 17.9392 20.8851 17.7382 20.6809L15.984 18.8997C15.3387 18.2366 15.3387 17.1803 15.984 16.5172V16.5172C16.2934 16.2029 16.7161 16.0259 17.1572 16.0259C17.5982 16.0259 18.0209 16.2029 18.3303 16.5172Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetCare);
export default __webpack_public_path__ + "static/media/get-care.eba436bfeafb2631cce1dac31a0b0609.svg";
export { ForwardRef as ReactComponent };